export default __webpack_public_path__ + "static/media/section1-bg3.74e1d638.svg";